import React from "react";
import { Accordion } from "flowbite-react";
import { Icon } from "@iconify/react";
import MultiSelect from "../MultiSelect";

const PatientFilters = ({
  filterVal,
  setFilterVal,
  Patientfilter,
  selectedLocations,
  selectedTeams,
  onLocationsChange,
  onTeamsChange,
  onFilter,
  onReset,
  onGroupNameChange,
  onSearchSideEffect,
}) => {

  const dobToInputValue = (dob) => {
    if (!dob) return "";
    if (dob.includes("/")) {
      const [month, day, year] = dob.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
    return dob;
  };

  const handleChangesearch = (e) => {
    const value = e.target.value;
    setFilterVal((prev) => ({ ...prev, search: value }));
    onSearchSideEffect?.(value);
  };

  const handleDOBChanges = (e) => {
    const inputDate = e.target.value; 
    if (inputDate) {
      const [year, month, day] = inputDate.split("-");
      setFilterVal((prev) => ({ ...prev, dob: `${month}/${day}/${year}` }));
    } else {
      setFilterVal((prev) => ({ ...prev, dob: "" }));
    }
  };

  const handleChange = (e) => {
    setFilterVal((prev) => ({ ...prev, tag: e.target.value }));
  };

  const handleGroupChange = (e) => {
    const groupKey = e.target.value;
    setFilterVal((prev) => ({ ...prev, group: groupKey }));
    onGroupNameChange?.(Patientfilter?.groups?.[groupKey] || "");
  };

  const handleStatusChanges = (e) => {
    setFilterVal((prev) => ({ ...prev, status: e.target.value }));
  };

  const FilterType = (e) => {
    setFilterVal((prev) => ({ ...prev, patient_login: e.target.value }));
  };

  const handleSelectedLocations = (selectedIds) => {
    onLocationsChange(selectedIds);
    setFilterVal((prev) => ({ ...prev, locations: selectedIds }));
  };

  const handleSelectedTeams = (selectedIds) => {
    onTeamsChange(selectedIds);
    setFilterVal((prev) => ({ ...prev, team: selectedIds }));
  };

  const selectClass =
    "block py-2.5 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-everglade-900 appearance-none dark:text-white dark:border-everglade-600 dark:focus:border-everglade-500 focus:outline-none focus:ring-0 focus:border-everglade-600 peer";

  const labelClass =
    "absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-everglade-600 peer-focus:dark:text-everglade-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto";

  const labelClassSearch =
    "absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] start-2.5 peer-focus:text-everglade-600 peer-focus:dark:text-everglade-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto";

  return (
    <Accordion className="tour-list-filters w-full px-0 flex col-span-3 flex-wrap items-center">
      <Accordion.Panel>
        <Accordion.Title className="w-full text-everglade-900">
          Filter
        </Accordion.Title>
        <Accordion.Content className="w-full">

          <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 justify-stretch">

            <div className="relative z-0 mb-5 me-0 sm:me-5 lg:mb-0">
              <select
                id="filter_availability"
                value={filterVal?.patient_login || ""}
                onChange={FilterType}
                className={selectClass}
              >
                <option value="">All</option>
                <option value="1">Available</option>
                <option value="2">Unavailable</option>
              </select>
              <label htmlFor="filter_availability" className={labelClass}>
                Availability
              </label>
            </div>

            <div className="relative z-0 mb-5 me-0 sm:me-5 lg:mb-0">
              <input
                type="date"
                name="dob"
                id="filter_dob"
                onChange={handleDOBChanges}
                value={dobToInputValue(filterVal?.dob)}
                className={selectClass}
                placeholder=" "
              />
              <label htmlFor="filter_dob" className={labelClass}>
                DOB
              </label>
            </div>

            {Patientfilter?.patient_tags?.length > 0 && (
              <div className="relative z-0 mb-5 me-0 lg:me-5 lg:mb-0">
                <select
                  id="filter_tags"
                  value={filterVal?.tag || ""}
                  onChange={handleChange}
                  className={selectClass}
                >
                  <option value="">Patient Tag</option>
                  {Patientfilter.patient_tags.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.tag_name}
                    </option>
                  ))}
                </select>
                <label htmlFor="filter_tags" className={labelClass}>
                  Tags
                </label>
              </div>
            )}

            {Patientfilter?.groups && (
              <div className="relative z-0 mb-5 me-0 sm:me-5 lg:mb-0">
                <select
                  id="filter_groups"
                  value={filterVal?.group || ""}
                  onChange={handleGroupChange}
                  className={selectClass}
                >
                  <option value="">Patient Group</option>
                  {Object.entries(Patientfilter.groups).map(([key, value]) =>
                    value ? (
                      <option key={key} value={key}>
                        {value}
                      </option>
                    ) : null
                  )}
                </select>
                <label htmlFor="filter_groups" className={labelClass}>
                  Groups
                </label>
              </div>
            )}

            <div className="relative z-0 mb-5 me-0 sm:me-5 lg:me-0 lg:mb-0">
              <select
                id="filter_status"
                value={filterVal?.status || ""}
                onChange={handleStatusChanges}
                className={selectClass}
              >
                <option value="">All</option>
                <option value="active">Active</option>
                <option value="inactive">InActive</option>
              </select>
              <label htmlFor="filter_status" className={labelClass}>
                Status
              </label>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 justify-stretch mt-0 lg:mt-6">

            <div className="relative sm:col-span-2 mb-5 me-0 sm:me-5 lg:mb-0">
              <input
                type="text"
                id="filter_search"
                value={filterVal?.search || ""}
                onChange={handleChangesearch}
                className="tour-list-searchname w-full block rounded-t-lg px-2.5 pb-2.5 pt-5 text-sm text-gray-900 dark:bg-gray-700 border-0 border-b-2 border-gray-900 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-everglade-500 focus:outline-none focus:ring-0 focus:border-everglade-600 peer"
                placeholder=" "
              />
              <label htmlFor="filter_search" className={labelClassSearch}>
                Search By Name
              </label>
            </div>

            {Patientfilter?.locations && (
              <div className="relative z-0 sm:col-span-1 mb-5 me-0 lg:me-5 lg:mb-0">
                <MultiSelect
                  key={`locations-${selectedLocations.join("-")}`}
                  component="Locations"
                  options={Patientfilter.locations}
                  property="location_name"
                  handleSelection={handleSelectedLocations}
                  selectedValues={selectedLocations}
                />
                <label htmlFor="filter_locations" className={labelClassSearch}>
                  Locations
                </label>
              </div>
            )}

            {Patientfilter?.teams && (
              <div className="relative z-0 sm:col-span-1 mb-5 me-0 sm:me-5 lg:mb-0">
                <MultiSelect
                  key={`teams-${selectedTeams.join("-")}`}
                  component="Teams"
                  options={Patientfilter.teams}
                  property="tname"
                  handleSelection={handleSelectedTeams}
                  selectedValues={selectedTeams}
                />
                <label htmlFor="filter_teams" className={labelClassSearch}>
                  Teams
                </label>
              </div>
            )}

            <div className="mb-5 me-0 mt-5 lg:mt-0 sm:me-5 lg:me-0 lg:mb-0 col-span-1 flex flex-col sm:flex-row gap-2">
              {onFilter && (
                <button
                  type="button"
                  onClick={onFilter}
                  className="tour-list-apply flex-1 text-white bg-everglade-700 hover:bg-everglade-800 focus:ring-4 focus:ring-everglade-300 font-medium rounded-lg text-sm px-4 py-2.5 dark:bg-everglade-600 dark:hover:bg-everglade-700 focus:outline-none dark:focus:ring-everglade-800"
                >
                  Filter
                </button>
              )}

              <button
                type="button"
                onClick={onReset}
                className="tour-list-reset flex-1 text-everglade-700 hover:text-white border border-everglade-700 hover:bg-everglade-800 focus:ring-4 focus:outline-none focus:ring-everglade-300 font-medium rounded-lg text-sm px-4 py-2.5 text-center dark:border-everglade-500 dark:text-everglade-500 dark:hover:text-white dark:hover:bg-everglade-600 dark:focus:ring-everglade-800"
              >
                <Icon icon="mdi:filter-off" className="inline-block mr-1" />
                Reset
              </button>
            </div>
          </div>

        </Accordion.Content>
      </Accordion.Panel>
    </Accordion>
  );
};

export default PatientFilters;